import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardMedia, Typography, Grid, Box } from '@mui/material'
import { API_BASE_URL } from '../../../../config/api'
import DoneIcon from '@mui/icons-material/Done'
import DeviceUnknown from '@mui/icons-material/DeviceUnknown'
import PeopleIcon from '@mui/icons-material/People'
import { InnerChip, AvatarContainer } from './styled'
import noAvatar from '../../../../assets/images/no-avatar.png'
import { useTranslation } from 'react-i18next'

const CommunityListItem = ({ group, selectCommunity }) => {
  const { t } = useTranslation()

  const handleImageRenderError = (e) => {
    e.target.src = noAvatar
  }

  return (
    <div
      onClick={() => selectCommunity(group)}
      style={{ cursor: 'pointer', position: 'relative', width: '100%' }}
    >
      <Card
        style={{
          padding: '5px',}}
      >
        <CardMedia
          component="img"
          src={group?.group?.image ? `${API_BASE_URL}${group?.group?.image}` : noAvatar}
          alt="Community Image"
          onError={handleImageRenderError}
          style={{
            objectFit: 'cover', // Crop the image if needed
            width: '100%'
          }}
        />
        <Box
          style={{
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Typography
            style={{
              marginTop: '4px',
              fontSize: '16px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              fontWeight: 'bold'
            }}
          >
            {group?.group?.name}
          </Typography>
          <Typography
            style={{
              marginTop: '6px',
              fontSize: '12px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              color: 'gray',
            }}
          >
            {group?.group?.description}
          </Typography>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={6}>
              <Typography
                style={{
                  fontSize: '14px',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap'
                }}
              >
                {t(`community.role.${group?.role}`)}
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Typography
                style={{
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <PeopleIcon style={{ marginRight: '4px' }} />
                {group?.group?.memberCount} {/* Assuming `memberCount` is the number of members */}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </div>
  )
}

CommunityListItem.propTypes = {
  group: PropTypes.object,
  selectCommunity: PropTypes.func
}

export default CommunityListItem
